var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationEllipse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 85,
    viewBox: "0 0 468 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466 42.5C466 44.6318 464.817 46.9965 461.918 49.5694C459.028 52.135 454.649 54.7031 448.822 57.2052C437.184 62.2028 420.22 66.7494 399.106 70.5842C356.91 78.248 298.535 83 234 83C169.465 83 111.09 78.248 68.8944 70.5842C47.7802 66.7494 30.8163 62.2028 19.178 57.2052C13.3511 54.7031 8.97219 52.135 6.08168 49.5694C3.1828 46.9965 2 44.6318 2 42.5C2 40.3682 3.1828 38.0035 6.08168 35.4306C8.97219 32.865 13.3511 30.2969 19.178 27.7948C30.8163 22.7972 47.7802 18.2506 68.8944 14.4158C111.09 6.75204 169.465 2 234 2C298.535 2 356.91 6.75204 399.106 14.4158C420.22 18.2506 437.184 22.7972 448.822 27.7948C454.649 30.2969 459.028 32.865 461.918 35.4306C464.817 38.0035 466 40.3682 466 42.5Z",
    stroke: "url(#paint0_radial)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-56.5 42) rotate(18.2008) scale(232.113 1143.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationEllipse);
export default __webpack_public_path__ + "static/media/LocationEllipse.708f9476f4c9a5cd9870eae329a1e9ba.svg";
export { ForwardRef as ReactComponent };